"use client";

import { useCardModal } from "modules/cards/stores/useCardsStore";
import React, { useCallback, useMemo } from "react";
import Link from "next/link";
import { Modal } from "modules/common/components/Modal/Modal";
import { CardDetailsContent } from "modules/common/components/CardDetailsDialog/CardDetailsContent";
import { useCardByDataId } from "modules/cards/hooks/useCardByDataId";
import { CardDetailsDialogSkeleton } from "./CardDetailsDialogSkeleton";
import { CardActionsButton } from "modules/cards/actions/components/CardActionsButton";
import { getCardUrl } from "utils/utils";
import { PricingProvider } from "modules/common/components/Providers/PricingProvider";

export default function CardDetailsModal() {
  const { modal, closeModal } = useCardModal();
  const { open, card, dataId, game, finish, pricing } = modal;

  const { card: fetchedCard, isFetching } = useCardByDataId({
    dataId: dataId || "",
    game,
    enabled: !!dataId && !!game && !card,
    pricing,
  });

  const displayCard = card || fetchedCard;

  const handleClose = useCallback(() => {
    closeModal();
  }, [closeModal]);

  const desktopActions = useMemo(() => {
    if (!displayCard) return null;

    return (
      <>
        <button className="btn btn-md">Close</button>
        <CardActionsButton
          card={displayCard}
          variant="button"
          className="btn-md btn btn-accent"
        >
          Add
        </CardActionsButton>
        <Link
          href={getCardUrl(displayCard, finish)}
          className="btn btn-primary"
          onClick={handleClose}
        >
          View Details
        </Link>
      </>
    );
  }, [displayCard, handleClose, finish]);

  // Keep dialog mounted for smooth animations

  // Use stable key and conditional content to prevent double animation
  const dialogTitle = displayCard?.name || "Loading...";

  return (
    <Modal
      showCloseButton
      key={dataId}
      open={open}
      onClose={handleClose}
      title={dialogTitle}
      actions={displayCard ? desktopActions : undefined}
    >
      {displayCard ? (
        pricing ? (
          <PricingProvider pricing={pricing}>
            <CardDetailsContent displayCard={displayCard} finish={finish} />
          </PricingProvider>
        ) : (
          <CardDetailsContent displayCard={displayCard} finish={finish} />
        )
      ) : (
        <CardDetailsDialogSkeleton />
      )}
    </Modal>
  );
}
